import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { SEO } from '../components/SEO';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faCircleXmark, faSpinner } from '@fortawesome/free-solid-svg-icons';

export const VerifyEmail = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token');
  const [status, setStatus] = useState('verifying');
  const [message, setMessage] = useState('');

  useEffect(() => {
    if (token) verifyToken();
    else { setStatus('error'); setMessage('No verification token found.'); }
  }, [token]);

  const verifyToken = async () => {
    try {
      const response = await fetch(`/auth/verify-email?token=${encodeURIComponent(token)}`, {
        method: 'GET'
      });
      const data = await response.json();
      if (response.ok) {
        setStatus('success');
        setMessage(data.message || 'Email verified successfully!');
        setTimeout(() => navigate('/setup-payment'), 2000);
      } else { setStatus('error'); setMessage(data.message || 'Verification failed.'); }
    } catch { setStatus('error'); setMessage('Network error. Please try again.'); }
  };

  return (
    <>
      <SEO title="Verify Email | GHLWA" canonical="https://app.ghlwa.com/verify-email" />
      <div className="min-h-screen flex items-center justify-center" style={{ background: 'linear-gradient(160deg, #1e1b4b 0%, #3730a3 100%)' }}>
        <div className="bg-white rounded-2xl shadow-glass p-10 text-center max-w-md w-full mx-4">
          <img src="/ghlwa.png" alt="GHLWA" className="h-14 w-auto mx-auto mb-6" />
          {status === 'verifying' && (
            <>
              <FontAwesomeIcon icon={faSpinner} className="animate-spin text-primary-600 text-4xl mb-4" />
              <h2 className="text-xl font-bold text-secondary-900 mb-2">Verifying your email...</h2>
              <p className="text-secondary-500 text-sm">Please wait a moment.</p>
            </>
          )}
          {status === 'success' && (
            <>
              <div className="w-16 h-16 bg-primary-100 rounded-full flex items-center justify-center mx-auto mb-5">
                <FontAwesomeIcon icon={faCheckCircle} className="text-primary-600 text-3xl" />
              </div>
              <h2 className="text-2xl font-bold text-secondary-900 mb-3">Email verified!</h2>
              <p className="text-secondary-500 mb-2">{message}</p>
              <p className="text-xs text-secondary-400">Redirecting to setup...</p>
            </>
          )}
          {status === 'error' && (
            <>
              <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-5">
                <FontAwesomeIcon icon={faCircleXmark} className="text-red-500 text-3xl" />
              </div>
              <h2 className="text-2xl font-bold text-secondary-900 mb-3">Verification failed</h2>
              <p className="text-secondary-500 mb-6">{message}</p>
              <a href="/login" className="btn-primary inline-block">Back to login</a>
            </>
          )}
        </div>
      </div>
    </>
  );
};
